module.exports = __webpack_public_path__ + "static/media/wtrans.6e1a9a2c.pdf";